import { render, staticRenderFns } from "./PersonGridByRole.vue?vue&type=template&id=cac24728&scoped=true"
import script from "./PersonGridByRole.vue?vue&type=script&lang=js"
export * from "./PersonGridByRole.vue?vue&type=script&lang=js"
import style0 from "./PersonGridByRole.vue?vue&type=style&index=0&id=cac24728&prod&scoped=true&lang=css"
import style1 from "./PersonGridByRole.vue?vue&type=style&index=1&id=cac24728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac24728",
  null
  
)

export default component.exports